import {
  isCommitmentAppointmentType,
  translateAppointmentTypeLabel,
} from '../constants/appointmentTypes';
import { billingModeDisplayLabel } from './appointmentBilling';

export const patientAgeLabel = (appt: any): string | null => {
  const bd = appt.clinic_patients?.birth_date ?? (appt as any).patient_birth_date;
  if (!bd) return null;
  try {
    const today = new Date();
    const birth = new Date(bd + (bd.length <= 10 ? 'T12:00:00' : ''));
    if (Number.isNaN(birth.getTime())) return null;
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
    if (age < 0 || age > 150) return null;
    return `${age} ano${age === 1 ? '' : 's'}`;
  } catch {
    return null;
  }
};

export const billingModeShortLabel = (appt: any): string => billingModeDisplayLabel(appt);

const normalizeDisplayName = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

/** Feegow: título veio do export; vínculo por legacy_csv_id pode apontar outro paciente (IDs repetidos entre unidades). */
const feegowDisplayPatientName = (appt: any, nameFallback: string): string => {
  const title = String(appt.title || '').trim();
  const linked = String(appt.clinic_patients?.full_name || '').trim();
  const generic = new Set(['', 'paciente', 'consulta', 'compromisso']);
  if (
    appt.metadata?.import_source === 'feegow_agendamentos_structured_csv'
    && title
    && linked
    && !generic.has(title.toLowerCase())
    && normalizeDisplayName(title) !== normalizeDisplayName(linked)
  ) {
    return title;
  }
  return (linked || title || nameFallback).trim() || nameFallback;
};

export const apptDetailFields = (appt: any, nameFallback: string) => {
  const isCommitment = isCommitmentAppointmentType(appt.appointment_type);
  const iclinicPatientName = String(appt.metadata?.doctoralia_patient_name || '').trim();
  const name = isCommitment
    ? (iclinicPatientName || (appt.title || 'Compromisso').trim())
    : feegowDisplayPatientName(appt, nameFallback);
  const age = patientAgeLabel(appt);
  const typeLabel = translateAppointmentTypeLabel(appt.appointment_type);
  const billing = billingModeShortLabel(appt);
  const notes = (appt.notes || '').replace(/\s+/g, ' ').trim();
  const prof = (appt.clinic_professionals?.full_name || '').trim();
  const unit = String(
    appt.agenda_unit_name
    || appt.unit?.short_name
    || appt.unit?.name
    || '',
  ).trim();
  const timeStart = appt.start_time?.substring(0, 5) || '';
  const timeEnd = appt.end_time?.substring(0, 5) || '';
  return { name, age, typeLabel, billing, notes, prof, unit, timeStart, timeEnd };
};

/** Mescla paciente do painel quando o agendamento não trouxe join clinic_patients. */
export function enrichAppointmentForDisplay(
  apt: any,
  patient?: { full_name?: string | null; birth_date?: string | null } | null,
): any {
  if (!patient?.birth_date && !patient?.full_name) return apt;
  return {
    ...apt,
    clinic_patients: apt.clinic_patients ?? {
      full_name: patient.full_name ?? undefined,
      birth_date: patient.birth_date ?? undefined,
    },
  };
}
